<template>
  <div class="menu__pagination" v-if="totalCount != 0">
    <button class="btn-arr-l" :disabled="currentPage == 1 || totalCount == 0" @click="changeCurrentPage(currentPage - 1 > 1 ? currentPage - 1 : 1)">
      이전
    </button>

    <div class="txt-btwbtn" style="width: auto">
      <span class="txt-page current-page2">{{ totalCount == 0 ? 0 : currentPage }}</span>
      <span class="txt-page"> / </span>
      <span class="txt-page">{{ totalCount % pageCount == 0 ? Math.floor(totalCount / pageCount) : Math.floor(totalCount / pageCount) + 1 }}</span>
    </div>
    <button
      class="btn-arr-r"
      :disabled="currentPage == maxPage || totalCount == 0"
      @click="changeCurrentPage(currentPage + 1 < maxPage ? currentPage + 1 : maxPage)"
    >
      다음
    </button>
  </div>
</template>
<script>
export default {
  name: 'mainPaging',
  props: {
    totalCount: Number,
    pageCount: Number,
    currentPage: Number,
  },
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  computed: {
    maxPage() {
      // 총 페이지 수(and 최대 페이지 번호)
      return Math.ceil(this.totalCount / this.pageCount);
    },
    startPage() {
      // 페이지 시작 번호
      return Math.trunc((this.currentPage - 1) / this.pageCount) * this.pageCount + 1;
    },
    endPage() {
      // 페이지 끝 번호
      let end = this.startPage + this.pageCount - 1;
      return end < this.maxPage ? end : this.maxPage;
    },
    paginationUnits() {
      // 화면에 표시할 페이지 배열..
      let units = [];
      for (let num = this.startPage; num <= this.endPage; num++) {
        units.push(num);
      }
      return units;
    },
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  methods: {
    changeCurrentPage(page) {
      // 페이지 변경
      if (this.currentPage !== page) {
        // 변경된 페이지 전송
        this.$emit('changePage', page);
      }
    },
  },
  watch: {
    darkMode(value) {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>
<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/main.css" scoped></style>
<style src="@/assets/css/user/pages/lst-allergy.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/main-dark.css" scoped></style>
<style src="@/assets/css/user/dark/lst-allergy-dark.css" scoped></style>
